import React, { useEffect, useState } from 'react';
import { wtApiCall } from '../../helpers/commons/ApiWrapper';
import { lzNotifyErrorMessageFromResult } from '../../helpers/commons/notifications';
import { CButton, CCard, CCardBody, CCardHeader, CCardTitle } from '@coreui/react';
import DataTable from '../../widgets/DataTables/DataTable';
import RowCount from '../../widgets/DataTables/RowCount';
import getColumnSearchProps, { getDropdownSearchProps } from '../../widgets/Filters/ColumnSearch';
import './style.css';
import CIcon from '@coreui/icons-react';
import { cilFile } from '@coreui/icons';
import SlidingTicker from '../SlidingTicker/SlidingTicker'
import { TenderModel, TYPE_NAMES, TYPE_DROPDOWN_OPTIONS, TENDER_STATUS_APPROVED, TENDER_OPEN, TENDER_STATUS_HOD_APPROVED } from '../../models/tender.js'
import TenderTabs from '../../widgets/tabs/TenderTabs'
import { wtGetDateMonthYearFormat } from '../../../src/helpers/commons/moment.js'
import newTenderGif from '../../assets/img/gif.gif'; 
import moment from 'moment';
import pdfIcon from "./pdf.png"
export default function Tenders() {
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [OpenTender, setOpenTender] = useState(1);
    const [filterTitle, setFilterTitle] = useState('');
    const [filterUploadDate, setfilterUploadDate] = useState('');
    const [filterOpenDate, setfilterOpenDate] = useState('');
    const [filterType, setFilterType] = useState('');
    const [filterTypeName, setFilterTypeName] = useState('');

    const [displayFromCount, setDisplayFromCount] = useState(0);
    const [displayToCount, setDisplayToCount] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const [currentPage, setCurrentPage] = useState(1);
    const onTableChange = (pagination, filter, sorter) => {
        const current_page = pagination.current
        const Size = pagination.pageSize
        setPageSize(Size)
        setCurrentPage(current_page)
        getData(current_page, Size, sorter)
      }

    const changeValues = (key, val) => {
        if (key == 'type') {
            setFilterType(val.value)
            setFilterTypeName(val.label)
        }
    }

    const getData = (page = '', size = '', sorter = {}) => {
        setIsLoading(true);
        wtApiCall(
            'tenders',
            {
                _page_index: page ? page : currentPage,
                _page_size: size ? size : pageSize,
                _sort_order: sorter ? sorter : [],
                tender_title: filterTitle,
                type: filterType,
                status: TENDER_OPEN,
                open_date: filterOpenDate,
                upload_date: filterUploadDate,
                approval_status: TENDER_STATUS_HOD_APPROVED,

            },
            'get',
            (response) => {
                setData(response.data.data);
                setTotalRecords(response.data.total);
                setDisplayFromCount(response.data.from);
                setDisplayToCount(response.data.to);
                setIsLoading(false);
            },
            (error) => {
                lzNotifyErrorMessageFromResult(error);
            },
        );
    };


    const columns = [
        {
            key: 'tender_title',
            title: () => (
                <div>
                    Tender Title
                    {filterTitle && (
                        <>
                            <br />
                            <span style={{ color: 'blue' }}>
                                Filtering: <span style={{ color: 'green' }}>"{filterTitle}"</span>
                            </span>
                        </>
                    )}
                </div>
            ),
            sorter: true,
            sortDirections: ['ascend', 'descend'],
            width: 500, // Set your desired width here
            ...getColumnSearchProps('tender_title', filterTitle, setFilterTitle, getData),
            render: (record) => {
                // Calculate if the tender is created within the last two days
                const createdAt = moment(record.created_at); // Assuming record.created_at holds the created date
                const isNewTender = createdAt.isAfter(moment().subtract(2, 'days')); // Check if within 2 days
    
                return (
                    <span>
                   
                    {record.tender_title} 
                    {isNewTender && <img src={newTenderGif} alt="New Tender" style={{ width: '35px', height: '17px' }} />} {/* Blinking GIF */}
                    <br />
                    <span style={{color:'darkblue'}}>({record.tender_enquiry_no} Dated: {record.upload_date})</span> <br />
                </span>
                );
            },
        },
        {
            key: 'type',
            title: () => (
                <div>
                    Tender Type
                    {filterTypeName && (
                        <>
                            <br />
                            <span style={{ color: 'blue' }}>
                                Filtering: <span style={{ color: 'green' }}>"{filterTypeName}"</span>
                            </span>
                        </>
                    )}
                </div>
            ),
            dataIndex: 'type',
            render: (text, record) => (
                <span>
                    {TYPE_NAMES[text]}
                </span>
            ),
            sorter: true,
            width: 150, // Set your desired width here

            sortDirections: ['ascend', 'descend'],
            ...getDropdownSearchProps
                (
                    'type',
                    TYPE_DROPDOWN_OPTIONS,
                    changeValues,
                    'Select tYPE',
                    getData,
                ),
        },

        {
            key: 'upload_date',
            title: () => (
                <div>
                    Upload Date
                    {filterUploadDate && (
                        <>
                            <br />
                            <span style={{ color: 'blue' }}>
                                Filtering: <span style={{ color: 'green' }}>"{filterUploadDate}"</span>
                            </span>
                        </>
                    )}
                </div>
            ),
            width: 150, // Set your desired width here
            render: (text) => {
                return <span style={{ color: 'blue' }}>{wtGetDateMonthYearFormat(text)}</span>
            },
            dataIndex: 'upload_date',
            sorter: true,
            sortDirections: ['ascend', 'descend'],
            ...getColumnSearchProps('upload_date', filterUploadDate, setfilterUploadDate, getData),
        },

        {
            key: 'open_date',
            title: () => (
                <div>
                    Open Date
                    {filterOpenDate && (
                        <>
                            <br />
                            <span style={{ color: 'blue' }}>
                                Filtering: <span style={{ color: 'green' }}>"{filterOpenDate}"</span>
                            </span>
                        </>
                    )}
                </div>
            ),
            dataIndex: 'open_date',
            render: (text) => {
                return <span style={{ color: 'blue' }}>{wtGetDateMonthYearFormat(text)}</span>
            },
            width: 150, // Set your desired width here
            sorter: true,
            sortDirections: ['ascend', 'descend'],
            ...getColumnSearchProps('open_date', filterOpenDate, setfilterOpenDate, getData),
        },
        {
            key: 'download',
            title: 'Download',
            dataIndex: 'media',
            width: 100, // Set your desired width here

            render: (text, record) => (

                record.media.map((item) => (
                    <a
                        color="info"
                        style={{ marginLeft: '10px' }}
                        href={item.file_preview_path}
                        target='blank'
                    >
                        <img src={pdfIcon} />
                    </a>
                ))
            ),
        },
    ];

    useEffect(() => {
    getData('', '', { order: 'ascend', columnKey: 'open_date' })

    }, []);

    return (
        <>
            {/* <SlidingTicker /> */}

            <TenderTabs tab_id={1} />

            <CCard className="card-dark container mt-1">
                <CCardHeader>
                    <CCardTitle className="text-black tenders-label">Tenders</CCardTitle>
                </CCardHeader>
                <CCardBody>
                    <DataTable
                        data={data}
                        columns={columns}
                        pageSize={pageSize}
                        totalRecords={totalRecords}
                        onTableChange={onTableChange}
                        isLoading={isLoading}
                        currentPage={currentPage}
                    />
                    <RowCount
                        displayFromCount={displayFromCount}
                        displayToCount={displayToCount}
                        totalRecords={totalRecords}
                    />
                </CCardBody>
            </CCard>
        </>
    );
}